
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const ActualSize = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="ActualSize" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M10.707 10l4.64649 4.64648-.7071.707-4.6463-4.64624-.00006 2.79321H9V9.0022h.00226V9h4.49817v1zM5.99988 5.29272L1.35358.64648l-.7071.707L5.293 6H2.49957v1h4.49817v-.0022H7V2.49951H5.99994zM9.0022 7h4.49829V6l-2.79321-.00012 4.64624-4.64636-.707-.707L10 5.293V2.49951H9V6.9978h.0022zM6.9978 9H2.49951v1l2.79321.00012-4.64624 4.64636.707.707L6 10.707v2.79346h1V9.0022h-.0022z" />
</svg>
    </HvIconBase>
)};

ActualSize.propTypes = HvIconBase.propTypes;

export default ActualSize;